export const UploadQuoteLabels = {
  quoteUpload: "Quote Upload",
  commodityFilterName: "Commodity",
  negotiationMonth: "Negotiation Month:",
  negotiationWeek: "Negotiation Week:",
  note: "Note: ",
  executeAssessment: "Execute Assessment",
  commodityKey: "commodity",
  emptyMessage: "No data found corresponding to selected filters.",
  uploadProjectedRelease: "Upload Projected Release",
  uploadAgentPricing: "Upload Market Pricing",
  editCommodityIndex: "Edit Commodity Index",
  upload: "Upload",
  uploaded: "Uploaded",
  save: "Save",
  downloadTemp: "Template",
};

export const UploadQuotesNotes = [
  "Execute Assessment will push the volume allocation and board cost setting pages to the current negotiation month. It is recommended to wait until all quotes are uploaded before executing",
  "The latest quote uploaded will always be considered for board cost calculations, regardless of start date",
  "If there is a fourth quote, replace the third quote",
 
];

export const QuoteUploadStatus = [
  // {
  //   header: "Commodity",
  //   field: "commodity",
  // },
  {
    field: "vendor",
    header: "Supplier",
  },
  {
    field: "firstQuote",
    header: "First Quote",
  },
  {
    field: "secondQuote",
    header: "Second Quote",
  },
  {
    field: "thirdQuote",
    header: "Third Quote",
  },
  {
    field: "midMonthQuote",
    header: "Mid Month Quote",
  },
];

export const AdditionalQuoteUploadStatus = [
  {
    field: "vendor",
    header: "Supplier",
  },
  {
    field: "uploadStatus​",
    header: "Upload Status​",
  },
];
